import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrowCombine = () => {
  return (
    <g>
      <path d="m15.5322 7.3935-4.125-2.3814a.7.7 0 0 0 -1.05.6065v1.6814h-1.6912a5.0313 5.0313 0 0 1 -4.3092-2.3146 2.3761 2.3761 0 0 0 .56-1.522 2.4 2.4 0 1 0 -2.4 2.4 2.3665 2.3665 0 0 0 .6751-.1086 6.816 6.816 0 0 0 2.5032 2.2452 6.816 6.816 0 0 0 -2.5034 2.2453 2.3665 2.3665 0 0 0 -.6751-.1086 2.4 2.4 0 1 0 2.4 2.4 2.376 2.376 0 0 0 -.56-1.522 5.0312 5.0312 0 0 1 4.3094-2.3147h1.6914v1.6811a.7.7 0 0 0 1.05.6065l4.125-2.3814a.7.7 0 0 0 0-1.2129zm-14.0146-3.9301a1 1 0 1 1 .999 1 1 1 0 0 1 -.999-1zm.999 10.0727a1 1 0 1 1 1-1 1 1 0 0 1 -1 1zm9.2412-4.3672v-2.3379l2.0244 1.169z" />
    </g>
  );
};

export default withIcon(IconArrowCombine);
